/*
 * @Description: 路由配置列表
 * @Author: gonghong
 * @Date: 2024-02-19 16:18:25
 * @LastEditTime: 2024-02-21 13:59:54
 */
import Layout from '@/layout/index.vue'
export const staticRoutes = [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login/index.vue'),
        meta: { title: '登录' },
    },
    {
        path: '/',
        component: Layout,
        redirect: '/home',
        children: [
            {
                path: '/home',
                component: () => import('@/views/home/index.vue'),
            },
            {
                path: '/mission',
                name: 'mission',
                component: () => import('@/views/detailMission/index.vue'),
                meta: { title: '待办事项' },
            },
            {
                path: '/info',
                name: 'info',
                component: () => import('@/views/detailInfo/index.vue'),
                meta: { title: '消息提醒' },
            },
            {
                path: '/ads',
                name: 'ads',
                component: () => import('@/views/detailAds/index.vue'),
                meta: { title: '公告通知' },
            },
            {
                path: '/adsDetail',
                name: 'adsDetail',
                component: () => import('@/views/detailAds/detail.vue'),
                meta: { title: '公告内容' },
            },
            {
                path: '/userInfo',
                name: 'userInfo',
                component: () => import('@/views/userInfo/index.vue'),
                meta: { title: '个人中心' },
            },
            {
                path: '/helpCenter',
                name: 'helpCenter',
                component: () => import('@/views/helpCenter/index.vue'),
                meta: { title: '帮助中心' },
            },
            {
                path: '/helpCenter/components/PdfView',
                name: 'PdfView',
                component: () => import('@/views/helpCenter/components/PdfView/index.vue'),
                meta: { title: '文件预览' },
            },
        ],
    },
]
